export default __webpack_public_path__ + "static/pto-70f233cc0af92e3e71393a21359d4b49.png";